import { GetSignupBrandingResponse } from '@iwoca/lapi-client/edge';
import { IwocaLogo } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import { clsx } from 'clsx';

import styles from './LogoHeading.module.css';

type TProps = {
  logo: GetSignupBrandingResponse['logo'];
  signup_branding_type: GetSignupBrandingResponse['signup_branding_type'];
  partner_name: GetSignupBrandingResponse['partner_name'];
};

const LogoHeadingContent = ({
  logo,
  signup_branding_type,
  partner_name,
}: TProps) => {
  const brandingType = signup_branding_type;
  const logoSrc = logo;
  const logoAlt = `${partner_name} logo`;
  // Needed because some SVGs don't have a width
  const isLogoSvg = logo?.includes('.svg');

  if (brandingType === 'iwoca' || !logoSrc) {
    return (
      <div className={styles.container}>
        <div className={styles.logoContainer}>
          <div data-testid="iwoca-logo">
            <IwocaLogo className={styles.iwocaLogo} />
          </div>
        </div>
      </div>
    );
  }

  if (brandingType === 'combined') {
    return (
      <div className={styles.container}>
        <div className={styles.partialBrandingLogos}>
          <div className={styles.partialBrandingIwocaLogoContainer}>
            <IwocaLogo />
          </div>
          <span className={styles.partnershipWith}>
            <Trans>Partnership with</Trans>
          </span>
          <div
            className={clsx(styles.partialBrandingLogoContainer, {
              [styles.svgPartialBrandingLogoContainer]: isLogoSvg,
            })}
          >
            <img className={styles.logo} src={logoSrc} alt={logoAlt} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <img className={styles.logo} src={logoSrc} alt={logoAlt} />
      </div>
    </div>
  );
};

export default LogoHeadingContent;
